import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="px-4 md:px-6 py-12">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="text-lg font-heading font-bold text-background-50 mb-4">
                <Link to="/" className="no-underline text-background-50 hover:text-primary-400 transition-colors cursor-pointer">
                  蚂蚁影视
                </Link>
              </h4>
              <p className="text-sm text-secondary-400 leading-relaxed">
                高清免费在线观看平台，即点即播不缓冲，海量电影电视剧每日更新，流畅追剧首选。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer no-underline"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快捷链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer no-underline">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer no-underline">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">免责声明</h4>
              <p className="text-xs text-secondary-500 leading-relaxed">
                本站内容来源于互联网公开资源，仅供学习和交流使用。如涉及版权问题，请及时联系我们处理。
              </p>
            </div>
          </div>

          <div className="border-t border-secondary-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-secondary-500">
              &copy; {new Date().getFullYear()} 蚂蚁影视. 保留所有权利.
            </p>
            <p className="text-xs text-secondary-500">
              本站内容仅供学习交流，不用于商业用途
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}